import React from "react";
import TaskStatusMenu from "./menu";
import TaskWorkflow, {WorkflowType} from "../../../../model2/status/task-workflow";
import Task from "../../../../model2/task/task";

type Props = {
    menuParams: {
        task            : Task,
        workflow        : TaskWorkflow,
        hint            : boolean // why ?
        classes         : string,
        togglePopover?  : callback
    }
}

export default function TaskMoreMenuStatus (props: Props): JSX.Element {

    const onStatusClick = (statusId: ID)=>{

        props.menuParams.togglePopover?.()

        props.menuParams.task.statusId = statusId;
        props.menuParams.task.save();
    }

    const onEditStatusesClick = () => {
        props.menuParams.togglePopover?.()

        if (props.menuParams.workflow.type===WorkflowType.TASK_FROM_PROJECT) {
            gd.goTo('p/'+props.menuParams.task.projectId+'/info/settings/workflow');
        } else {
            gd.goTo('settings/task-types/'+props.menuParams.task.taskTypeId);
        }
    }

    // const statusesGrouped = props.menuParams.workflow.getStatusesForSelector()
    const statuses = props.menuParams.workflow.models

    // return <TaskStatusMenu statusesGrouped     =   {statusesGrouped}
    //                        onStatusClick       =   {onStatusClick}
    //                        onEditStatusesClick =   {onEditStatusesClick}
    //                        hint                =   {props.menuParams.hint}
    //                        classes             =   {props.menuParams.classes}/>

    return <TaskStatusMenu statuses             =   {statuses}
                           onStatusClick        =   {onStatusClick}
                           onEditStatusesClick  =   {onEditStatusesClick}
                           hint                 =   {props.menuParams.hint}
                           classes              =   {props.menuParams.classes}/>
}
